import DarkModeSwitch from './DarkModeSwitch';

export default DarkModeSwitch;
